import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Ajoute l'en-tête `X-App-Source: arp-front` à toutes les requêtes sortantes.
 * Permet au backend Laravel (ARP) d'identifier l'origine de chaque
 * requête dans le journal d'activités, indépendamment du port de dev.
 */
@Injectable()
export class AppSourceInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloned = req.clone({
      setHeaders: { 'X-App-Source': 'portail' },
    });
    return next.handle(cloned);
  }
}
